export default __webpack_public_path__ + "static/media/gallery_00.4dd0cd20.jpg";